import { CreateArticleContentView } from "./CreateArticleContentView"

/** A tela de cadastro de usuário */
const CreateArticleView = () => {
	return (
		<>
			<CreateArticleContentView />
		</>
	)
}

export default CreateArticleView
